<!-- ============================================================================
     INTEGRAÇÃO GPL — Separação de vendas do Sistema Legado (Aerosys)
     Ver comentário de topo em estoque-separacao-itens-legado.component.ts
     ============================================================================ -->
<div class="es-shell">
  <div class="container">

    <!-- HEADER CARD -->
    <div class="header-card">
      <div class="hc-top">
        <button class="btn-voltar" (click)="onVoltar()">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          Voltar
        </button>
        <div class="hc-top-right">
          <span class="hc-badge">#{{ numVenda || idVenda }}</span>
          <span class="hc-tag-badge" title="Venda do Sistema Legado (Aerosys)">AERO</span>
          <!-- TAG física desta separação -- pra o separador conferir qual
               etiqueta/local usar sem precisar lembrar de cabeça. Só aparece
               depois de identificado (é quando a TAG fica definida). -->
          <span class="hc-taglegado-badge" *ngIf="identificado && tag" title="TAG física desta separação">
            TAG {{ tag }}
          </span>
          <!-- Quem está identificado nesta venda (lembrado ou recém-digitado) --
               "Trocar" esquece essa identificação e pede TAG+usuário de novo,
               pra troca de turno/separador nesta mesma venda. -->
          <span class="hc-quem-badge" *ngIf="identificado && nomeAtual" title="Identificado nesta venda: {{ nomeAtual }}">
            <span class="hc-quem-nome">{{ primeiroNome(nomeAtual) }}</span>
            <button type="button" class="hc-quem-trocar" (click)="trocarIdentificacao()">Trocar</button>
          </span>
        </div>
      </div>

      <!-- Ações -->
      <div class="hc-acoes" *ngIf="identificado && itens.length > 0">
        <button class="btn-dividir" (click)="abrirModalDividir()" title="Dividir separação com outro(s) separador(es)">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
          Dividir
        </button>
        <button class="btn-transferir" (click)="abrirModalTransferir()" title="Transferir separação para outro separador">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
          Transferir
        </button>
      </div>
    </div>

    <!-- STATES -->
    <div *ngIf="identificado && carregando" class="loading-state">
      <app-loading-indicator></app-loading-indicator>
      <span>Carregando itens...</span>
    </div>

    <div *ngIf="identificado && erro" class="alert alert-danger">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erro }}
    </div>

    <div *ngIf="identificado && erroSalvar" class="alert alert-danger" style="margin-bottom:12px">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
      {{ erroSalvar }}
    </div>

    <!-- LISTA DE ITENS -->
    <div class="content-card" *ngIf="identificado && !carregando && !erro && itens.length > 0">

      <div class="progress-bar-container">
        <div class="progress-info">
          <span>
            Itens separados ({{ totalSeparados }}/{{ itens.length }})
            <ng-container *ngIf="totalPendentesAbertas > 0"> · {{ totalPendentesAbertas }} no outro galpão</ng-container>
          </span>
          <span>{{ progresso }}%</span>
        </div>
        <div class="progress-bg">
          <div class="progress-fill" [style.width]="progresso + '%'"></div>
        </div>
      </div>

      <div class="abas-wrap">
        <button class="aba-btn" [class.ativa]="abaAtiva === 'pendentes'" (click)="abaAtiva = 'pendentes'">
          A Separar
          <span class="aba-count" [class.count-alert]="itensPendentes.length > 0">{{ itensPendentes.length }}</span>
        </button>
        <button class="aba-btn" [class.ativa]="abaAtiva === 'separados'" (click)="abaAtiva = 'separados'">
          Já Separados
          <span class="aba-count" [class.count-ok]="itensSeparadosLista.length > 0">{{ itensSeparadosLista.length }}</span>
        </button>
      </div>

      <!-- Aba: A Separar -->
      <div class="itens-list" *ngIf="abaAtiva === 'pendentes'">
        <div class="empty-aba" *ngIf="itensPendentes.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          Todos os itens foram separados!
        </div>
        <!-- Só mostra o PRÓXIMO item pendente por vez (ver itemPendenteAtual) -- ao marcar o check, revela o seguinte. -->
        <div class="sequencia-hint" *ngIf="itensPendentes.length > 0">
          Item {{ totalSeparados + 1 }} de {{ itens.length }}
        </div>
        <div class="item-card" *ngFor="let item of itemPendenteAtual" (click)="toggleItem(item)">
          <span class="item-ordem">{{ totalSeparados + 1 }}</span>
          <div class="checkbox-wrapper">
            <div class="custom-checkbox"></div>
          </div>
          <div class="item-details">
            <div class="campo-row" *ngIf="item.pn">
              <span class="campo-valor"><span class="pn-label">P/N</span> {{ item.pn }}</span>
              <span class="badge qty">Qtde: {{ item.quantidade }}</span>
            </div>
            <div class="campo-row" *ngIf="!item.pn">
              <span class="campo-valor">{{ item.descricao }}</span>
              <span class="badge qty">Qtde: {{ item.quantidade }}</span>
            </div>
            <div class="item-descricao" *ngIf="item.pn">{{ item.descricao }}</div>
            <div class="campo-row" *ngIf="item.cd">
              <span class="campo-valor"><span class="pn-label">CD</span> {{ item.cd }}</span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <div class="campo-row" *ngIf="item.apeId">
              <span class="campo-valor"><span class="pn-label">COD</span> {{ item.apeId }}</span>
              <span class="badge estoque" [class.negativo]="item.estoque <= 0" *ngIf="item.estoque !== undefined && item.estoque !== null" title="Saldo disponível">Disponível: {{ item.estoque }}</span>
            </div>
            <div class="serial-row" *ngIf="item.controlaSerial || item.formEscolhido">
              <span class="badge lote" *ngIf="item.formEscolhido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                FORM: {{ item.formEscolhido }}
              </span>
              <ng-container *ngIf="item.controlaSerial">
                <span class="badge serial" *ngIf="item.serialEscolhido">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                  SERIAL: {{ item.serialEscolhido }}
                </span>
                <span class="badge serial serial-pendente" *ngIf="!item.serialEscolhido">SERIAL: sem estoque disponível</span>
              </ng-container>
              <button class="btn-trocar-serial btn-trocar-lote" (click)="abrirModalTrocarForm(item, $event)" title="Trocar form/serial">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path></svg>
                Trocar
              </button>
            </div>
            <div class="consumo-lotes" *ngIf="item.consumoLotes && item.consumoLotes.length > 1">
              <span class="consumo-lotes-titulo">Consumir de {{ item.consumoLotes.length }} lotes (estoque insuficiente em um só):</span>
              <div class="consumo-lote-linha" *ngFor="let c of item.consumoLotes">
                <span class="consumo-lote-qtd">{{ c.quantidade }}x</span>
                <span class="consumo-lote-form" *ngIf="c.form">FORM: {{ c.form }}</span>
                <span class="consumo-lote-lote" *ngIf="c.lote">LOTE: {{ c.lote }}</span>
                <span class="consumo-lote-serial" *ngIf="c.serial">SERIAL: {{ c.serial }}</span>
              </div>
            </div>
            <div class="item-observacao" *ngIf="item.observacao">{{ item.observacao }}</div>
            <div class="item-acoes-row">
              <button class="btn-item-observacao" [class.tem-observacao]="!!item.observacao" (click)="abrirModalObservacaoItem(item, $event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                {{ item.observacao ? 'Editar observação' : 'Adicionar observação' }}
              </button>
              <button class="btn-item-pendencia" (click)="abrirModalPendencia(item, $event)" title="Sinalizar que este item está no outro galpão">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                Item no outro Galpão
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Aba: Já Separados -->
      <div class="itens-list" *ngIf="abaAtiva === 'separados'">
        <div class="empty-aba" *ngIf="itensSeparadosLista.length === 0">
          Nenhum item separado ainda.
        </div>
        <div class="item-card separado" [class.pendente-galpao]="item.pendente" *ngFor="let item of itensSeparadosLista; let i = index" (click)="!item.pendente && toggleItem(item)">
          <span class="item-ordem item-ordem-separado">{{ i + 1 }}</span>
          <div class="checkbox-wrapper">
            <div class="custom-checkbox" *ngIf="!item.pendente">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
            <div class="custom-checkbox custom-checkbox-pendente" *ngIf="item.pendente" title="Item no outro Galpão">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
            </div>
          </div>
          <div class="item-details">
            <div class="campo-row" *ngIf="item.pn">
              <span class="campo-valor"><span class="pn-label">P/N</span> {{ item.pn }}</span>
              <span class="badge qty">Qtde: {{ item.quantidade }}</span>
            </div>
            <div class="campo-row" *ngIf="!item.pn">
              <span class="campo-valor">{{ item.descricao }}</span>
              <span class="badge qty">Qtde: {{ item.quantidade }}</span>
            </div>
            <div class="item-descricao" *ngIf="item.pn">{{ item.descricao }}</div>
            <div class="campo-row" *ngIf="item.cd">
              <span class="campo-valor"><span class="pn-label">CD</span> {{ item.cd }}</span>
              <span class="badge loc" *ngIf="item.local">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                {{ item.local }}
              </span>
            </div>
            <div class="campo-row" *ngIf="item.apeId">
              <span class="campo-valor"><span class="pn-label">COD</span> {{ item.apeId }}</span>
              <span class="badge estoque" [class.negativo]="item.estoque <= 0" *ngIf="item.estoque !== undefined && item.estoque !== null" title="Saldo disponível">Disponível: {{ item.estoque }}</span>
            </div>
            <div class="serial-row" *ngIf="item.controlaSerial || item.formEscolhido">
              <span class="badge lote" *ngIf="item.formEscolhido">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
                FORM: {{ item.formEscolhido }}
              </span>
              <ng-container *ngIf="item.controlaSerial">
                <span class="badge serial" *ngIf="item.serialEscolhido">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                  SERIAL: {{ item.serialEscolhido }}
                </span>
                <span class="badge serial serial-pendente" *ngIf="!item.serialEscolhido">SERIAL: sem estoque disponível</span>
              </ng-container>
            </div>
            <div class="consumo-lotes" *ngIf="item.consumoLotes && item.consumoLotes.length > 1">
              <span class="consumo-lotes-titulo">Consumido de {{ item.consumoLotes.length }} lotes:</span>
              <div class="consumo-lote-linha" *ngFor="let c of item.consumoLotes">
                <span class="consumo-lote-qtd">{{ c.quantidade }}x</span>
                <span class="consumo-lote-form" *ngIf="c.form">FORM: {{ c.form }}</span>
                <span class="consumo-lote-lote" *ngIf="c.lote">LOTE: {{ c.lote }}</span>
                <span class="consumo-lote-serial" *ngIf="c.serial">SERIAL: {{ c.serial }}</span>
              </div>
            </div>
            <div class="item-meta" *ngIf="item.separadorNome && !item.pendente">
              <span class="badge unit">Separado por: {{ item.separadorNome }}</span>
            </div>
            <div class="pendencia-galpao-box" *ngIf="item.pendente">
              <span class="badge pendencia-galpao-badge">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                Item no outro Galpão
              </span>
              <span class="pendencia-galpao-obs" *ngIf="item.pendenteObservacao">{{ item.pendenteObservacao }}</span>
            </div>
            <div class="item-observacao" *ngIf="item.observacao">{{ item.observacao }}</div>
            <div class="item-acoes-row">
              <button class="btn-item-observacao" [class.tem-observacao]="!!item.observacao" (click)="abrirModalObservacaoItem(item, $event)">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                {{ item.observacao ? 'Editar observação' : 'Adicionar observação' }}
              </button>
              <button class="btn-item-desfazer-pendencia" *ngIf="item.pendente" (click)="desfazerPendencia(item, $event)" [disabled]="desfazendoPendenciaIvdId === item.ivdId">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>
                {{ desfazendoPendenciaIvdId === item.ivdId ? 'Desfazendo...' : 'Desfazer sinalização' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="action-footer">
        <ng-container *ngIf="allDone">
          <div class="banner-todos-separados">
            <div class="banner-icone">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            </div>
            <div class="banner-texto">
              <strong>Todos os itens foram separados!</strong>
              <span>Deseja finalizar a separação desta venda?</span>
            </div>
          </div>
          <button class="btn-concluir" (click)="finalizar()" [disabled]="finalizando">
            <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            {{ finalizando ? 'Finalizando...' : 'Finalizar Separação' }}
          </button>
        </ng-container>

        <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin-top:12px">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          {{ erroFinalizar }}
        </div>
      </div>

    </div>
  </div>
</div>

<!-- ── RESTAURANDO IDENTIFICAÇÃO LEMBRADA (silencioso, sem modal) ────────── -->
<!-- Essa venda já foi identificada antes neste navegador (ver ngOnInit) --
     confirma a sessão existente no Aerosys em vez de perguntar TAG/usuário
     de novo. Some sozinho assim que os itens chegarem (ou volta pro modal
     normal, se por algum motivo a sessão não colar mais). -->
<div class="modal-overlay" *ngIf="!identificado && restaurandoIdentificacao">
  <div class="modal-box" style="text-align:center; padding:36px 32px">
    <app-loading-indicator style="margin:0 auto 14px"></app-loading-indicator>
    <span style="color:var(--text-muted)">Retomando identificação anterior...</span>
  </div>
</div>

<!-- ── MODAL IDENTIFICAÇÃO "QUEM SOU VOCÊ" (TAG + usuário) ─────────────── -->
<!-- Igual ao padrão do modal de TAG do Sankhya (estoque-separacao), mas com
     busca de usuário também -- o Aerosys não tem como saber quem está usando
     a tela via JWT, então precisa dos dois campos antes de liberar a lista. -->
<div class="modal-overlay" *ngIf="!identificado && !restaurandoIdentificacao">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:6px"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        Quem está separando?
      </h2>
    </div>
    <div class="modal-body">
      <p class="modal-desc">O Aerosys não sabe quem está usando esta tela — informe sua TAG e selecione o seu usuário antes de continuar.</p>

      <label class="id-label">TAG</label>
      <!-- Fonte bem grande, igual ao modal de TAG do Sankhya -- o separador
           vai ler isso de longe / com luva (ver .tag-big-input no CSS). -->
      <input
        #tagInputAerosys
        type="text"
        class="tag-big-input"
        [ngModel]="tag"
        (ngModelChange)="onTagInputChange($event)"
        placeholder="00"
        maxlength="2"
        autocomplete="off"
        inputmode="numeric"
        pattern="[0-9]*"
      />
      <p class="id-hint">Informe o número da TAG (01 a 40) -- mesma TAG física usada no Sankhya.</p>

      <label class="id-label">Usuário</label>
      <div class="busca-usuario-wrap">
        <input
          #buscaUsuarioInput
          type="text"
          class="id-input"
          [(ngModel)]="buscaUsuario"
          (ngModelChange)="onBuscaUsuarioChange()"
          placeholder="Digite seu nome"
          [disabled]="!!usuarioEscolhido"
        />
        <button class="btn-limpar-usuario" *ngIf="usuarioEscolhido" (click)="limparUsuarioEscolhido()">Trocar</button>
      </div>
      <div class="loading-seriais" *ngIf="buscandoUsuarios">
        <app-loading-indicator size="inline"></app-loading-indicator> Buscando usuários...
      </div>
      <div class="seriais-lista" *ngIf="!usuarioEscolhido && usuariosSugeridos.length > 0">
        <div class="serial-opcao" *ngFor="let u of usuariosSugeridos" (click)="escolherUsuario(u)">
          <div class="serial-opcao-info">
            <span class="serial-opcao-num">{{ u.nome }}</span>
          </div>
        </div>
      </div>
      <div class="empty-seriais" *ngIf="!usuarioEscolhido && !buscandoUsuarios && !erroIdentificacao && usuariosSugeridos.length === 0 && buscaUsuario.trim().length >= 2">
        Nenhum usuário encontrado para "{{ buscaUsuario }}".
      </div>

      <div *ngIf="erroIdentificacao" class="alert alert-danger" style="margin-top:12px">{{ erroIdentificacao }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-concluir" (click)="confirmarIdentificacao()" [disabled]="!tag.trim() || !usuarioEscolhido || identificando">
        <span *ngIf="!identificando">Continuar</span>
        <span *ngIf="identificando"><app-loading-indicator size="inline"></app-loading-indicator> Aguarde...</span>
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL FINALIZAR SEPARAÇÃO ─────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalFinalizar" (click)="modalFinalizar = false">
  <div class="modal-box modal-finalizar" (click)="$event.stopPropagation()">
    <div class="modal-finalizar-body">
      <div class="modal-finalizar-icone">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
      </div>
      <h2>Todos os itens foram separados!</h2>
      <p>Deseja finalizar a separação desta venda?</p>
      <div class="modal-finalizar-acoes">
        <button class="btn-cancelar-modal" (click)="modalFinalizar = false">Agora não</button>
        <button class="btn-concluir btn-concluir-modal" (click)="finalizarDoModal()" [disabled]="finalizando">
          <svg *ngIf="!finalizando" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          {{ finalizando ? 'Finalizando...' : 'Finalizar Separação' }}
        </button>
      </div>
      <div *ngIf="erroFinalizar" class="alert alert-danger" style="margin-top:12px">{{ erroFinalizar }}</div>
    </div>
  </div>
</div>

<!-- ── MODAL TROCAR FORM/SERIAL ──────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalTrocarForm" (click)="fecharModalTrocarForm()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>{{ passoTrocar === 'lotes' ? 'Trocar Form' : 'Escolher Serial' }}</h2>
      <button class="btn-fechar-modal" (click)="fecharModalTrocarForm()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc" *ngIf="itemTrocando">
        <strong>{{ itemTrocando.pn }}</strong> — {{ itemTrocando.descricao }}
      </p>

      <!-- Passo 1: escolher o lote (form fixo daquele lote) -->
      <ng-container *ngIf="passoTrocar === 'lotes'">
        <div class="loading-seriais" *ngIf="buscandoLotes">
          <app-loading-indicator size="inline"></app-loading-indicator> Carregando lotes disponíveis...
        </div>
        <div class="empty-seriais" *ngIf="!buscandoLotes && lotesDisponiveis.length === 0 && !erroTrocar">
          Nenhum lote com saldo disponível no momento.
        </div>
        <div class="seriais-lista" *ngIf="!buscandoLotes && lotesDisponiveis.length > 0">
          <div
            class="serial-opcao"
            *ngFor="let l of lotesDisponiveis"
            [class.serial-opcao-atual]="l.form === itemTrocando?.formEscolhido"
            (click)="escolherLote(l)"
          >
            <div class="serial-opcao-info">
              <span class="serial-opcao-num">Form: {{ l.form }}</span>
              <span class="serial-opcao-fab" *ngIf="l.lote">Lote: {{ l.lote }}</span>
              <span class="serial-opcao-fab" *ngIf="l.dataCompra">Compra: {{ l.dataCompra }}</span>
              <span class="serial-opcao-fab">{{ itemTrocando?.controlaSerial ? (l.qtdDisponivel + ' serial(is) disponível(is)') : ('Saldo: ' + l.qtdDisponivel) }}</span>
            </div>
            <span class="serial-opcao-atual-badge" *ngIf="l.form === itemTrocando?.formEscolhido">Atual</span>
          </div>
        </div>
      </ng-container>

      <!-- Passo 2: escolher o serial dentro do lote (só peça com serial) -->
      <ng-container *ngIf="passoTrocar === 'seriais'">
        <div class="serial-atual" *ngIf="loteEscolhido">
          <span class="serial-atual-label">Lote escolhido:</span>
          <span class="badge lote">Form: {{ loteEscolhido.form }}</span>
        </div>
        <div class="loading-seriais" *ngIf="buscandoSeriais">
          <app-loading-indicator size="inline"></app-loading-indicator> Carregando seriais do lote...
        </div>
        <div class="empty-seriais" *ngIf="!buscandoSeriais && seriaisDoLote.length === 0 && !erroTrocar">
          Nenhum serial disponível nesse lote no momento.
        </div>
        <div class="seriais-lista" *ngIf="!buscandoSeriais && seriaisDoLote.length > 0">
          <div
            class="serial-opcao"
            *ngFor="let s of seriaisDoLote"
            [class.serial-opcao-atual]="s.ns === itemTrocando?.serialEscolhido"
            (click)="s.ns !== itemTrocando?.serialEscolhido && escolherSerial(s)"
          >
            <div class="serial-opcao-info">
              <span class="serial-opcao-num">{{ s.ns }}</span>
            </div>
            <span class="serial-opcao-atual-badge" *ngIf="s.ns === itemTrocando?.serialEscolhido">Atual</span>
          </div>
        </div>
      </ng-container>

      <div class="trocando-overlay" *ngIf="trocando">
        <app-loading-indicator size="inline"></app-loading-indicator> Salvando troca...
      </div>
      <div *ngIf="erroTrocar" class="alert alert-danger" style="margin-top:12px">{{ erroTrocar }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" *ngIf="passoTrocar === 'seriais'" (click)="voltarParaLotes()" [disabled]="trocando">Voltar</button>
      <button class="btn-cancelar-modal" (click)="fecharModalTrocarForm()" [disabled]="trocando">Fechar</button>
    </div>
  </div>
</div>

<!-- ── MODAL DIVIDIR SEPARAÇÃO ───────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalDividir" (click)="fecharModalDividir()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Dividir Separação</h2>
      <button class="btn-fechar-modal" (click)="fecharModalDividir()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        Escolha até 2 separadores adicionais. Os itens ainda pendentes serão divididos
        igualmente entre <strong>{{ nomeAtual }}</strong> e os escolhidos.
      </p>

      <div class="selecionados-dividir" *ngIf="selecionadosDividir.length > 0">
        <span class="chip-separador" *ngFor="let u of selecionadosDividir">
          {{ u.nome }}
          <button class="btn-remover-chip" (click)="removerSeparadorDividir(u)">×</button>
        </span>
      </div>

      <input
        type="text"
        class="id-input"
        *ngIf="selecionadosDividir.length < 2"
        [(ngModel)]="buscaUsuarioDividir"
        (ngModelChange)="onBuscaUsuarioDividirChange()"
        placeholder="Digite o nome do separador"
      />

      <div class="loading-seriais" *ngIf="buscandoUsuariosDividir">
        <app-loading-indicator size="inline"></app-loading-indicator> Buscando usuários...
      </div>
      <div class="seriais-lista" *ngIf="usuariosSugeridosDividir.length > 0">
        <div class="serial-opcao" *ngFor="let u of usuariosSugeridosDividir" (click)="adicionarSeparadorDividir(u)">
          <div class="serial-opcao-info">
            <span class="serial-opcao-num">{{ u.nome }}</span>
          </div>
        </div>
      </div>
      <div class="empty-seriais" *ngIf="selecionadosDividir.length < 2 && !buscandoUsuariosDividir && !erroDividir && usuariosSugeridosDividir.length === 0">
        Nenhum usuário encontrado{{ buscaUsuarioDividir ? (' para "' + buscaUsuarioDividir + '"') : '' }}.
      </div>

      <div class="trocando-overlay" *ngIf="dividindo">
        <app-loading-indicator size="inline"></app-loading-indicator> Dividindo separação...
      </div>
      <div *ngIf="erroDividir" class="alert alert-danger" style="margin-top:12px">{{ erroDividir }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalDividir()" [disabled]="dividindo">Cancelar</button>
      <button class="btn-concluir" (click)="confirmarDivisao()" [disabled]="dividindo || selecionadosDividir.length === 0">
        Confirmar Divisão
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL TRANSFERIR SEPARAÇÃO ────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalTransferir" (click)="fecharModalTransferir()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Transferir Separação</h2>
      <button class="btn-fechar-modal" (click)="fecharModalTransferir()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc">
        Selecione o separador que vai continuar esta separação. Depois de transferir,
        você não terá mais acesso a esta venda.
      </p>

      <div class="selecionados-dividir" *ngIf="usuarioEscolhidoTransferir">
        <span class="chip-separador">
          {{ usuarioEscolhidoTransferir.nome }}
          <button class="btn-remover-chip" (click)="limparUsuarioEscolhidoTransferir()">×</button>
        </span>
      </div>

      <input
        type="text"
        class="id-input"
        *ngIf="!usuarioEscolhidoTransferir"
        [(ngModel)]="buscaUsuarioTransferir"
        (ngModelChange)="onBuscaUsuarioTransferirChange()"
        placeholder="Digite o nome do separador"
      />

      <div class="loading-seriais" *ngIf="buscandoUsuariosTransferir">
        <app-loading-indicator size="inline"></app-loading-indicator> Buscando usuários...
      </div>
      <div class="seriais-lista" *ngIf="!usuarioEscolhidoTransferir && usuariosSugeridosTransferir.length > 0">
        <div class="serial-opcao" *ngFor="let u of usuariosSugeridosTransferir" (click)="escolherUsuarioTransferir(u)">
          <div class="serial-opcao-info">
            <span class="serial-opcao-num">{{ u.nome }}</span>
          </div>
        </div>
      </div>
      <div class="empty-seriais" *ngIf="!usuarioEscolhidoTransferir && !buscandoUsuariosTransferir && !erroTransferir && usuariosSugeridosTransferir.length === 0">
        Nenhum usuário encontrado{{ buscaUsuarioTransferir ? (' para "' + buscaUsuarioTransferir + '"') : '' }}.
      </div>

      <div class="trocando-overlay" *ngIf="transferindo">
        <app-loading-indicator size="inline"></app-loading-indicator> Transferindo separação...
      </div>
      <div *ngIf="erroTransferir" class="alert alert-danger" style="margin-top:12px">{{ erroTransferir }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalTransferir()" [disabled]="transferindo">Cancelar</button>
      <button class="btn-concluir" (click)="confirmarTransferencia()" [disabled]="transferindo || !usuarioEscolhidoTransferir">
        Confirmar Transferência
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL OBSERVAÇÃO DO ITEM ──────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalObservacao" (click)="fecharModalObservacao()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Observação do Item</h2>
      <button class="btn-fechar-modal" (click)="fecharModalObservacao()" [disabled]="salvandoObservacao">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc" *ngIf="itemObservando">
        <strong>{{ itemObservando.pn || itemObservando.descricao }}</strong> -- registre algo que o próximo
        separador ou o conferente precisa saber sobre ESTE item: ex.: "não tem o item", "quantidade
        encontrada é menor que a pedida".
      </p>
      <textarea
        class="observacao-textarea"
        [(ngModel)]="observacaoRascunho"
        placeholder="Digite a observação..."
        rows="5"
        maxlength="2000"
        [disabled]="salvandoObservacao"
      ></textarea>
      <div *ngIf="erroObservacao" class="alert alert-danger" style="margin-top:12px">{{ erroObservacao }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalObservacao()" [disabled]="salvandoObservacao">Cancelar</button>
      <button class="btn-concluir" (click)="salvarObservacaoItem()" [disabled]="salvandoObservacao"><app-loading-indicator *ngIf="salvandoObservacao" size="inline"></app-loading-indicator>
        {{ salvandoObservacao ? 'Salvando...' : 'Salvar Observação' }}
      </button>
    </div>
  </div>
</div>

<!-- ── MODAL "ITEM NO OUTRO GALPÃO" ──────────────────────────────────── -->
<div class="modal-overlay" *ngIf="modalPendencia" (click)="fecharModalPendencia()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Item no outro Galpão</h2>
      <button class="btn-fechar-modal" (click)="fecharModalPendencia()" [disabled]="marcandoPendente">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
      </button>
    </div>
    <div class="modal-body">
      <p class="modal-desc" *ngIf="itemPendencia">
        <strong>{{ itemPendencia.pn || itemPendencia.descricao }}</strong> -- este item não está aqui, está no
        galpão vizinho. Ele sai da fila "A Separar" (você segue pro próximo) e fica visível na tela global
        "Itens Pendentes" até alguém buscar e confirmar. Você ainda pode <strong>Finalizar</strong> a separação
        desta venda com o item sinalizado assim.
      </p>
      <textarea
        class="observacao-textarea"
        [(ngModel)]="pendenciaObservacaoRascunho"
        placeholder="Nota opcional (ex.: 'está no galpão 2, prateleira B')"
        rows="4"
        maxlength="2000"
        [disabled]="marcandoPendente"
      ></textarea>
      <div *ngIf="erroPendencia" class="alert alert-danger" style="margin-top:12px">{{ erroPendencia }}</div>
    </div>
    <div class="modal-footer">
      <button class="btn-cancelar-modal" (click)="fecharModalPendencia()" [disabled]="marcandoPendente">Cancelar</button>
      <button class="btn-concluir" (click)="confirmarPendencia()" [disabled]="marcandoPendente">
        {{ marcandoPendente ? 'Sinalizando...' : 'Sinalizar Pendência' }}
      </button>
    </div>
  </div>
</div>
